<template>
    <div>
        <el-row v-show="activeCreateForm">
            <h2>{{mode.name}}</h2>
            <el-col :span="24" class="addZipcodeForm">
                <el-form>
                    <el-form-item>
                        <el-row v-show="activeSelectSubDistrictAndZipcodeInput">
                            <el-col :span="6" :offset="1">
                                <el-input
                                    v-model="editForm"
                                    placeholder= "เพิ่มรหัสไปรษณีย์"
                                    maxlength="5"
                                    show-word-limit
                                    clearable
                                    type="text"
                                    @input="onCreateText"/>
                            </el-col>
                        </el-row>
                        <el-row v-show="!activeSelectSubDistrictAndZipcodeInput">
                            <el-col :span="6" :offset="1">
                                <el-input
                                    v-model="editForm"
                                    placeholder= "เพิ่มข้อมูล"
                                    clearable
                                    type="text"
                                    @input="onCreateText"/>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="6" :offset="1">
                                <el-select
                                    v-model="provinceForm"
                                    placeholder="จังหวัด"
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="item in provinceInfo"
                                        :key="item.provinceId"
                                        :label="item.provinceName"
                                        :value="item.provinceName"
                                        autocomplete="off"/>
                                </el-select>
                            </el-col>
                            <el-col v-show="activeSelectDistrictAndSubDistrict" :span="6" :offset="2">
                                <el-select
                                    v-model="districtForm"
                                    :disabled="false"
                                    placeholder="อำเภอ"
                                    clearable
                                    filterable
                                >
                                    <el-option
                                        v-for="item in districtArray"
                                        :key="item.districtId"
                                        :label="item.districtName"
                                        :value="item.districtName"/>
                                </el-select>
                            </el-col>
                            <el-col v-show="activeSelectSubDistrictAndZipcodeInput" :span="6" :offset="2">
                                <el-select
                                    v-model="subDistrictForm"
                                    clearable
                                    filterable
                                    placeholder="ตำบล"
                                    :disabled="false">
                                    <el-option
                                        v-for="item in subDistrictArray"
                                        :key="item.subDistrictId"
                                        :label="item.name"
                                        :value="item.name"/>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <el-button
                                    :disabled="isCreateActive"
                                    type="warning"
                                    plain
                                    @click="confirmCreate()"
                                >
                                    {{mode.name}}
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import fgApi from '@/services/fillgoods'

export default {
    name: 'ZipcodeSystemCreate',
    props: {
        mode: {
            type: Object,
            default: () => {
                return {
                    key: '',
                    name: ''
                }
            }
        }
    },
    data () {
        return {
            editForm: '',
            provinceForm: '',
            districtForm: '',
            subDistrictForm: '',
            zipcodeInput: '',
            districtInput: '',
            subDistrictInput: '',
            districtArray: [],
            subDistrictArray: [],
            subDistrictWasAlready: [],
            provId: null,
            distId: null,
            subDistId: null,
            provinceInfo: null,
            districtInfo: null,
            subDistrictInfo: null,
            zipcodeInfo: [],
            mapDistrict: null,
            mapSubDistrict: null,
            thaiDB: null,
            thaiSubDistDB: null,
            thaiZipcodeDB: null,
            thaiSubDistJson: null,
            diffAddInfo: [],
            sameArrayData: [],
            diffSubDistInfo: [],
            diffDistrictInfo: [],
            diffSubData: {},
            indexSubDiff: 0,
            loading: false,
            isCreateActive: true,
            isZipcodeActive: false,
            isDistrictActive: false,
            isSubDistActive: false
        }
    },
    computed: {
        activeSelectDistrictAndSubDistrict () {
            return this.mode.key === 1 || this.mode.key === 3
        },
        activeSelectSubDistrictAndZipcodeInput () {
            return this.mode.key === 1
        },
        activeCompareTb () {
            return this.mode.key === 0
        },
        activeCreateForm () {
            return this.mode.key !== 0
        }
    },
    watch: {
        mode (val) {
            if (val.key) {
                this.clearDataInput()
            }
        },
        provinceForm (val) {
            this.provinceSelect(val)
            if (val !== '') {
                this.checkCreateActive(val)
            }
        },
        districtForm (val) {
            this.districtSelect(val)
            if (val !== '') {
                this.checkCreateActive(val)
            }
        },
        subDistrictForm (val) {
            this.subDistrictSelect(val)
            if (val !== '') {
                this.checkCreateActive(val)
            }
        },
        zipcodeInput (val) {
            this.checkCreateActive(val)
        },
        districtInput (val) {
            this.checkCreateActive(val)
        },
        subDistrictInput (val) {
            this.checkCreateActive(val)
        }
    },
    created () {
        this.getAddress()
    },
    methods: {
        checkCreateActive (val) {
            switch (this.mode.key) {
            case 1:
                this.isZipcodeActive = true
                if (this.districtForm && this.subDistrictForm && this.provinceForm && this.zipcodeInput) {
                    this.isZipcodeActive = false
                } else {
                    this.isZipcodeActive = true
                }
                this.isCreateActive = this.isZipcodeActive
                break
            case 2:
                this.isZipcodeActive = true
                if (this.provinceForm && this.districtInput) {
                    this.isDistrictActive = false
                } else {
                    this.isDistrictActive = true
                }
                this.isCreateActive = this.isDistrictActive
                break
            case 3:
                this.isZipcodeActive = true
                if (this.districtForm && this.provinceForm && this.subDistrictInput) {
                    this.isSubDistActive = false
                } else {
                    this.isSubDistActive = true
                }
                this.isCreateActive = this.isSubDistActive
                break
            }
        },
        clearDataInput () {
            this.editForm = ''
            this.districtForm = ''
            this.subDistrictForm = ''
            this.provinceForm = ''
            this.zipcodeInput = ''
            this.districtInput = ''
            this.subDistrictInput = ''
            this.subDistrictArray = []
            this.districtArray = []
        },
        onCreateText (val) {
            switch (this.mode.key) {
            case 1: // add zipcode
                if (val.match(/^[\d\s]+$/g)) {
                    this.editForm = val
                    this.zipcodeInput = this.editForm
                } else {
                    this.editForm = ''
                }
                break
            case 2: // add district
                if (val.match(/^[ก-์]+$/ig)) {
                    this.editForm = val
                    this.districtInput = this.editForm
                } else {
                    this.editForm = ''
                }
                break
            case 3: // add subdistrict
                if (val.match(/^[ก-์]+$/ig)) {
                    this.editForm = val
                    this.subDistrictInput = this.editForm
                } else {
                    this.editForm = ''
                }
                break
            default:
                console.log('Sorry, out of val')
                break
            }
        },
        provinceSelect (val) {
            this.provinceForm = val
            console.log(this.provinceForm)
            this.provinceInfo.forEach((e) => {
                if (this.provinceForm === e.provinceName) {
                    this.provId = e.provinceId
                }
            })
            console.log('test', this.provId)
            this.districtArray = []
            if (this.provId === 77) {
                this.districtInfo = this.districtInfo.filter(e => {
                    return e.districtId < 999
                })
            }
            this.districtInfo.forEach((e) => {
                if (e.provinceId === this.provId) {
                    this.districtArray.push(e)
                }
            })
            this.districtForm = ''
            this.subDistrictForm = ''
        },
        async getAddress () {
            this.data = []
            this.getProvince()
            this.getDistrict()
            this.getSubDistrict()
        },
        async getProvince () {
            try {
                this.provinceInfo = []
                let paramProv = {
                    search: this.searchText
                }
                let resProv = await fgApi.order.searchProvince(paramProv)
                if (resProv.success) {
                    resProv.data.provinces.forEach(element => {
                        let data = element
                        this.provinceInfo.push(data)
                    })
                    this.provinceInfo.sort((a, b) => {
                        return a.provinceId - b.provinceId
                    })
                } else {
                    this.$message.error('get provicne not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api Province is error !')
            }
        },
        async getDistrict () {
            try {
                this.districtInfo = []
                let paramDist = {
                    search: this.searchText,
                    province_id: null
                }
                let resDist = await fgApi.order.searchDistrict(paramDist)
                if (resDist.success) {
                    resDist.data.districts.forEach(element => {
                        // console.log(element)
                        let data = element
                        this.districtInfo.push(data)
                    })
                    // console.log('district same', sameDist)
                } else {
                    this.$message.error('get district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api District is error !')
            }
        },
        async getSubDistrict () {
            try {
                this.subDistrictInfo = []
                let paramSubDist = {
                    search: ''
                }
                let resSubDist = await fgApi.order.searchSubDistrict(paramSubDist)
                if (resSubDist.success) {
                    resSubDist.data.subDistricts.forEach(element => {
                        let data = element
                        data.name = element.subDistrictName
                        this.subDistrictInfo.push(data)
                    })
                    this.subDistrictInfo.sort((a, b) => {
                        return a.subDistrictId - b.subDistrictId
                    })
                    // console.log('data', this.subDistrictInfo)
                } else {
                    this.$message.error('get sub-district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api Sub-District is error !')
            }
        },
        async districtSelect (val) {
            try {
                this.districtForm = val
                this.districtInfo.forEach((e) => {
                    if (e.districtName === this.districtForm) {
                        if (this.provId === 10 && e.districtName === 'เฉลิมพระเกียรติ') {
                            if (e.districtId < 240) {
                                this.distId = e.districtId
                            } else {
                                return
                            }
                        }
                        this.distId = e.districtId
                    }
                })
                let paramSubDist = {
                    district_id: this.distId,
                    province_id: this.provId
                }
                // console.log('check', paramSubDist)
                let resSubDist = await fgApi.order.searchSubDistrict(paramSubDist)
                if (resSubDist.success) {
                    this.subDistrictArray = []
                    // console.log('this', resSubDist.data)
                    resSubDist.data.subDistricts.forEach(e1 => {
                        let data = e1
                        data.name = e1.subDistrictName
                        this.subDistrictArray.push(data)
                    })
                    this.subDistrictArray.sort((a, b) => {
                        return a.subDistrictId - b.subDistrictId
                    })
                }
            } catch (error) {
                // console.log(error)
            }
            this.subDistrictForm = ''
        },
        subDistrictSelect (val) {
            this.subDistrictForm = val
            this.subDistrictArray.forEach((e) => {
                let data = this.subDistrictForm.indexOf(e.name)
                if (data !== -1) {
                    this.subDistId = e.subDistrictId
                }
            })
            console.log('test', this.subDistId)
        },
        async createInfo (val) {
            switch (val) {
            case 1: // single zipcode
                console.log(val)
                try {
                    let arr = []
                    let info = {
                        detail: this.zipcodeInput,
                        sub_district_id: this.subDistId,
                        district_id: this.distId,
                        province_id: this.provId
                    }
                    arr.push(info)
                    console.log('data Zipcode', arr)
                    let paramZip = { arr_zipcode: arr }
                    let resZip = await fgApi.order.createZipcode(paramZip)
                    if (resZip.success) {
                        console.log(resZip)
                        this.$message.success('Created zipcode success')
                    } else {
                        this.$message.error('Create zipcode not success')
                    }
                } catch (error) {
                    this.$message.error('Oops, Api is error !')
                }
                break
            case 2: // district
                try {
                    let paramDist = {
                        district_name: this.districtInput,
                        province_id: this.provId
                    }
                    console.log('data district', paramDist)
                    let resDist = await fgApi.order.createDistrict(paramDist)
                    if (resDist.success) {
                        console.log(resDist)
                        this.$message.success('Created district success')
                    } else {
                        this.$message.error('Create district not success')
                    }
                } catch (error) {
                    this.$message.error('Oops, Api is error !')
                }
                await this.getDistrict()
                break
            case 3: // subdistrict
                try {
                    let paramSubDist = {
                        sub_district_name: this.subDistrictInput,
                        district_id: this.distId,
                        province_id: this.provId
                    }
                    console.log('data Subdistrict', paramSubDist)
                    let resSubDist = await fgApi.order.createSubDistrict(paramSubDist)
                    if (resSubDist.success) {
                        console.log(resSubDist)
                        this.$message.success('Created subDistrict success')
                    } else {
                        this.$message.error('Create subdistrict not success')
                    }
                } catch (error) {
                    this.$message.error('Oops, Api is error !')
                }
                await this.getSubDistrict()
                break
            }
        },
        confirmCreate () {
            // console.log('test', val)
            this.$confirm('Are you sure to create ?', 'Warning', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.createInfo(this.mode.key)
                this.clearDataInput()
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: 'Created Canceled'
                })
            })
        }
    }
}
</script>
<style scope>
    .addZipcodeForm{
        margin-top: 20px
    }
    .el-row {
        margin-bottom: 10px;
    }
</style>
